const appSettings = {
  appStorageKeyPrefix: 'bb-',
  defaultAuthTimerCheckEveryXSeconds: 5 * 60,
  defaultRefreshEveryXSeconds: 20 * 60,
  logDateFormat: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  numberOfMinutesBeforeTokenExpiresToRefresh: 28,
  systemID: 'BedBoard'
};

export default appSettings;
